export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7013.b5b6ce7a.jpg";